/**
 * @copyright Copyright 2015 The MathWorks, Inc.
 */

/**
 Used by Focus Manager
 **/

define([
    "dojo/_base/declare"
], function (declare) {

    return declare(null, {
        //Override from Size Mixin of consolidated widget
        postCreate: function() {
            this.inherited(arguments);
            this.domNode.setAttribute("data-focus", "accept");
        }
    });
});
